/**
 * Upgrade `<a data-back-to-project>` elements to point at the last-visited
 * project when a fresh breadcrumb is stashed in sessionStorage. Server-side
 * session-based breadcrumb takes precedence (see components/header.blade.php),
 * this handler only runs on pages where the element is rendered without
 * a resolved href.
 */

const ONE_DAY_MS = 1000 * 60 * 60 * 24;

export function initProjectBreadcrumb() {
    try {
        const raw = sessionStorage.getItem('project_breadcrumb');
        if (!raw) return;

        const parsed = JSON.parse(raw);
        if (!parsed || !parsed.id) return;
        if (typeof parsed.at !== 'number') return;
        if (Date.now() - parsed.at > ONE_DAY_MS) return;

        const label = (window.i18n && window.i18n['Tilbage til projekt']) || 'Tilbage til projekt';
        const elements = document.querySelectorAll('[data-back-to-project]');

        elements.forEach((el) => {
            el.setAttribute('href', '/projects/' + parsed.id);
            el.textContent = '\u2190 ' + label;
        });
    } catch (_) {
        // sessionStorage or JSON.parse can throw — silently skip.
    }
}
